module.exports = __webpack_public_path__ + "static/img/membership_vip.66fb05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership_vip.png
// module id = QoB/
// module chunks = 1